import { render, staticRenderFns } from "./WidgetCarrentalStats.vue?vue&type=template&id=1afd68e5&scoped=true"
import script from "./WidgetCarrentalStats.vue?vue&type=script&lang=js"
export * from "./WidgetCarrentalStats.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarrentalStats.vue?vue&type=style&index=0&id=1afd68e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afd68e5",
  null
  
)

export default component.exports